import { all } from 'redux-saga/effects';
import authSaga from './modules/auth/saga';
import userSaga from './modules/user/saga';
import formsSaga from './modules/forms/saga';
import pagesSaga from './modules/pages/saga';
import targetsSaga from './modules/targets/saga';
import investmentsSaga from './modules/investments/saga';
import uiSaga from './modules/ui/saga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    userSaga(),
    pagesSaga(),
    formsSaga(),
    targetsSaga(),
    investmentsSaga(),
    uiSaga()
  ]);
}
